module.exports = __webpack_public_path__ + "img/icon-04.2180abab.svg";